import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    identityIdentified: undefined,
    selectedProject: undefined,
    displayedMessages: []
  },
  mutations: {
    login(state, identity) {
      if ( ! identity.keepSelectedProject ) {
        state.selectedProject = undefined;
      }
      if ((identity !== undefined) && (identity.email !== undefined)) {
        state.identityIdentified = {
          email: identity.email
        };
        if (identity.token) {
          state.identityIdentified.token = identity.token;
        }
        if (identity.refreshToken) {
          state.identityIdentified.refreshToken = identity.refreshToken;
        }
        if (identity.logout) {
          state.identityIdentified.logout = identity.logout;
        }
      }
    },
    logout(state) {
      if (state.identityIdentified && state.identityIdentified.logout) {
        state.identityIdentified.logout();
      }
      state.identityIdentified = undefined;
      state.selectedProject = undefined;
      state.displayedMessages = [];
    },
    selectProject(state, project) {
      if ((project !== undefined) && (project.id !== undefined) && (project.name !== undefined) && (project.collections !== undefined)) {
        state.selectedProject = {
          id: project.id,
          name: project.name,
          collections: project.collections
        };
      } else {
        state.selectedProject = undefined;
      }
    },
    unselectProject(state) {
      state.selectedProject = undefined;
    },
    addDisplayedMessage(state, message) {
      if ((message !== undefined) && (message.id !== undefined) && (message.text !== undefined) && (message.type !== undefined)) {
        state.displayedMessages.push({
          id: message.id,
          text: message.text,
          type: message.type,
          modalText: message.modalText,
          maxTimestamp: (message.maxTime !== undefined ) ? (Date.now() + message.maxTime) : undefined
        });
      }
      state.displayedMessages = state.displayedMessages.filter(function(obj){
        return ((obj.maxTimestamp === undefined) || (Date.now() < obj.maxTimestamp));
      });
    },
    removeDisplayedMessage(state, message) {
      if ((message !== undefined) && (message.id !== undefined)) {
        state.displayedMessages = state.displayedMessages.filter(function(obj){
          return ((obj.id !== message.id) && ((obj.maxTimestamp === undefined) || (Date.now() < obj.maxTimestamp)));
        });
      }
    }
  }
});
